import React from 'react';
import { Notification } from '.';

import AlbumIcon from '../SvgIcons/Album';
import CalendarIcon from '../SvgIcons/Calendar';
import ChatIcon from '../SvgIcons/Chat';
import ClipboardIcon from '../SvgIcons/Clipboard';
import FavStarIcon from '../SvgIcons/FavStar';
import GeoPinIcon from '../SvgIcons/GeoPin';
import GiftIcon from '../SvgIcons/Gift';
import GroupIcon from '../SvgIcons/Group';
import HandIcon from '../SvgIcons/Hand';
import HeartsIcon from '../SvgIcons/Hearts';
import InviteIcon from '../SvgIcons/Invite';
import MailIcon from '../SvgIcons/Mail';
import MobileHomeIcon from '../SvgIcons/MobileHome';
import MonitorIcon from '../SvgIcons/Monitor';
import PiggyBankIcon from '../SvgIcons/PiggyBank';
import PricePointsIcon from '../SvgIcons/PricePoints';
import Storefronticon from '../SvgIcons/Storefront';
import TruckIcon from '../SvgIcons/Truck';

import ChecklistIcon from '../SvgIcons/Checklist';
import { SeatingChartChairIcon } from '../SvgIconsV3/SeatingChartChair';

const notificationMapper = (itemType?: string): JSX.Element => {
  switch (itemType) {
    case Notification.PRODUCT_WEDDING_DOWNLOAD_CHECKLIST_CONVERSION_FIRST:
      return <ChecklistIcon />;
    case Notification.PRODUCT_WEDDING_SUPER_LINK_CONVERSION_FIRST:
      return <GroupIcon />;
    case Notification.PRODUCT_MARKETPLACE_VENDOR_CONVERSION_FIRST:
    case Notification.PRODUCT_MARKETPLACE_VENDOR_CONVERSION_SECOND:
    case Notification.INQUIRY_STOREFRONT_CONNECTED_BOOKED_STATE_STATUS:
    case Notification.MARKETPLACE_STOREFRONT_FAVORITED:
    case Notification.MARKETPLACE_STOREFRONT_OUTREACH:
    case Notification.MARKETPLACE_STOREFRONT_OUTREACH_FIRST_REMINDER:
      return <Storefronticon />;
    case Notification.PRODUCT_WEDDING_ADD_EVENT_CONVERSION_FIRST:
    case Notification.PRODUCT_WEDDING_WEBSITE_CONVERSION_FIRST:
    case Notification.PRODUCT_WEDDING_WEBSITE_CONVERSION_SECOND:
      return <MonitorIcon />;
    case Notification.PRODUCT_WEDDING_GUESTLIST_CONVERSION_FIRST:
    case Notification.POST_WEDDING_FIRST_REFER_FRIENDS:
      return <GroupIcon />;
    case Notification.PRODUCT_INVITE_SAVE_THE_DATE_CONVERSION_FIRST:
    case Notification.PRODUCT_INVITE_SAVE_THE_DATE_CONVERSION_SECOND:
    case Notification.POST_WEDDING_FIRST_SEND_THANK_YOU_CARDS:
    case Notification.POST_WEDDING_FIRST_PROMOTE_HOLIDAY_CARDS:
      return <InviteIcon />;
    case Notification.ADDRESS_COLLECTED:
      return <GeoPinIcon />;
    case Notification.GIFT_RECEIVED:
    case Notification.SURPRISE_GIFT_REVEALED:
    case Notification.PRODUCT_REGISTRY_CONVERSION_FIRST:
    case Notification.PRODUCT_REGISTRY_CONVERSION_SECOND:
    case Notification.POST_WEDDING_FIRST_SHIP_GIFTS:
      return <GiftIcon />;
    case Notification.INQUIRY_STOREFRONT_CONNECTED:
    case Notification.INQUIRY_STOREFRONT_CONNECTED_FIRST_REPLY_REMINDER:
    case Notification.INQUIRY_STOREFRONT_CONNECTED_SECOND_REPLY_REMINDER:
      return <ChatIcon />;
    case Notification.ORDER_SHIPPED:
      return <TruckIcon />;
    case Notification.RSVP:
    case Notification.TTW_BUDGET_TOOL_START:
    case Notification.TTW_CREDIT_USE:
    case Notification.TTW_CONTACT_COLLECTOR_START:
    case Notification.TTW_GUESTLIST_START:
    case Notification.TTW_WEDDING_REGISTRY_ADD_GIFTS:
    case Notification.TTW_WEDDING_REGISTRY_TRANSFER_FUNDS:
    case Notification.TTW_WEDDING_REGISTRY_START:
    case Notification.TTW_WEDDING_REGISTRY_PUBLISH:
    case Notification.TTW_WEDDING_REGISTRY_SHOP:
    case Notification.TTW_WEDDING_REGISTRY_SHIP_GIFTS:
    case Notification.TTW_WEDDING_WEBSITE_START:
    case Notification.TTW_WEDDING_WEBSITE_PUBLISH:
    case Notification.TTW_PAPER_SUITE_START:
    case Notification.TTW_PAPER_DAY_OF_START:
    case Notification.TTW_PAPER_INVITATIONS_START:
    case Notification.TTW_PAPER_SAVE_THE_DATE_START:
    case Notification.TTW_PAPER_THANK_YOU_CARDS_START:
    case Notification.TTW_PAPER_WEDDING_SHOWER_START:
    case Notification.TTW_PAPER_DAY_OF_ORDER:
    case Notification.TTW_PAPER_THANK_YOU_CARDS_ORDER:
    case Notification.TTW_PAPER_SAVE_THE_DATE_ORDER:
    case Notification.TTW_PAPER_WEDDING_SHOWER_ORDER:
    case Notification.TTW_SEATING_CHART_FINISH:
    case Notification.TTW_PAPER_INVITATIONS_ORDER:
    case Notification.TTW_PHOTOBOOK_START:
    case Notification.TTW_PHOTOBOOK_ORDER:
    case Notification.TTW_VM_CAKES_DESSERTS_EXPLORE:
    case Notification.TTW_VM_VENUES_EXPLORE:
    case Notification.TTW_VM_PHOTOGRAPHERS_EXPLORE:
    case Notification.TTW_VM_FLORISTS_EXPLORE:
    case Notification.TTW_VM_VIDEOGRAPHERS_EXPLORE:
    case Notification.TTW_VM_HAIR_MAKEUP_EXPLORE:
    case Notification.TTW_VM_VENDORS_EXPLORE:
    case Notification.TTW_VM_TRANSPORTATION_EXPLORE:
    case Notification.TTW_VM_HOTEL_BLOCKS_EXPLORE:
    case Notification.TTW_VM_VENDOR_REVIEW:
      return <CalendarIcon />;
    case Notification.WELCOME:
      return <HandIcon />;
    case Notification.WEDDING_DAY_CONGRATS:
      return <HeartsIcon />;
    case Notification.COMPLETION_DISCOUNT_AWARDED:
      return <PricePointsIcon />;
    case Notification.POST_WEDDING_FIRST_CREATE_WEDDING_ALBUM:
      return <AlbumIcon />;
    case Notification.POST_WEDDING_FIRST_READ_EXPERT_ADVICE:
      return <ClipboardIcon />;
    case Notification.ORDER_DELIVERED:
      return <MobileHomeIcon />;
    case Notification.FUNDS_TRANSFER_PAID:
    case Notification.BUDGET_UPCOMING_PAYMENT_REMINDER:
    case Notification.BUDGET_TOOL_REMINDER:
      return <PiggyBankIcon />;
    case Notification.COMMERCE_PRODUCT_REVIEW_REQUESTED:
    case Notification.POST_WEDDING_FIRST_REVIEW_MARKETPLACE_VENDOR:
      return <FavStarIcon />;
    case Notification.TTW_SEATING_CHART_START:
      return <SeatingChartChairIcon />;
    default:
      return <MailIcon />;
  }
};

export default notificationMapper;
